import fetchAPI from "../../../common/fetchAPI";
import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { PriorityStateClass } from "./interfaces/PriorityStateClass";
import { RootState } from "../../../app/store";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: PriorityStateClass = {
    isLoading: false,
    PriorityList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'Priority',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        priority: PriorityStateClass
    }
}

export const getAccountPrioritiesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Priority/v2/getAccountPriorities",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Priorities", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )

export const getAccountPriorityByPriorityIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Priority/v2/getAccountPriorityByPriorityId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Priorities/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )

export const addAccountPriorityAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Priority/v2/addAccountPriority",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Priorities/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountPriorityAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Priority/v2/updateAccountPriority",
        async (arg, thunkApi) => {
            const { AccountPriorityId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/Priorities/" + AccountPriorityId, "POST", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountPriorityAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Priority/v2/deleteAccountPriority",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Priorities/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )

export const DeleteSelectedAccountPriorityAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Priority/v2/DeleteSelectedAccountPriority",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/v2/Status/DeleteSelected/','Delete',arg,true,'0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/Priorities/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const prioritySlice = createSlice({
    name: "priority",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.PriorityList.findIndex((item) => item.AccountPriorityId == action.payload);
            const newArray = [...state.PriorityList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.PriorityList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.PriorityList.findIndex((item) => item.AccountPriorityId == action.payload);
            const newArray = [...state.PriorityList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.PriorityList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.PriorityList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.PriorityList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.PriorityList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.PriorityList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.PriorityList;
            state.PriorityList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getAccountPrioritiesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountPrioritiesAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                console.log('payload.Data:', Object.keys(payload.Data).length);
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.PriorityList = [];
                } else {
                    state.PriorityList = payload.Data;
                    state.PriorityList.map((item: any) => {
                        item.isSelected = 0
                    });
                }

                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountPrioritiesAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;
            })


            .addCase(getAccountPriorityByPriorityIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountPriorityByPriorityIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                
                state.isLoading = false;
            })
            .addCase(getAccountPriorityByPriorityIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(addAccountPriorityAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountPriorityAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountPriorityAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(updateAccountPriorityAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountPriorityAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountPriorityAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(deleteAccountPriorityAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountPriorityAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountPriorityAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountPriorityAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountPriorityAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountPriorityAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting } = prioritySlice.actions
export const priorityState = (state: RootState) => state.priority
export default prioritySlice.reducer